export class MathUtils {
    static convertFloat(value, precision = 1) {
        if (Number.isNaN(value)) {
            value = 0;
        }

        let resTmp = (value + "").trim();
        if (resTmp.endsWith(".")) {
            return value;
        }

        let result = Number.parseFloat(value);
        let res = Number.parseFloat(result.toFixed(precision));
        return res;
    }
}



// WEBPACK FOOTER //
// ./src/utils/MathUtils.js